import React from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import s from './ListOfBonuses.module.css';
import {useTranslation} from 'react-i18next';
import CreateCheckForm from './components/CreateCheckForm/CreateCheckForm';
import BonusesTable from './components/BonusesTable/BonusesTable';
import TableChecks from './components/ChecksTable/TableChecks';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const ListOfBonuses = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();

	if (!restrictions.canAccessWarehouseSection) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Список бонусів')} />
			<CreateCheckForm />
			<div className={s.tableWrapper}>
				<BonusesTable />
			</div>
			<div className={s.tableWrapper}>
				<TableChecks />
			</div>
		</div>
	);
};

export default ListOfBonuses;
